import { Col, Row } from 'antd';
import OwnerDashboard from 'modules/dashboard/components/OwnerDashboard';
import ProfileSideMenuWrapper from 'modules/navigation/components/ProfileSideMenuWrapper';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

const OwnerDashboardPage: FC = () => {
  const { t } = useTranslation('dashboard.DashboardPage');

  return (
    <ProfileSideMenuWrapper title={t('ownerDashboard')}>
      <Row gutter={[10, 10]} justify="space-between">
        <Col span={24}>
          <OwnerDashboard />
        </Col>
      </Row>
    </ProfileSideMenuWrapper>
  );
};

export default OwnerDashboardPage;
